var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", [
        _c(
          "div",
          { staticClass: "tlive-create__teacher--contain" },
          [
            _c(
              "yxt-tooltip",
              {
                staticClass: "item",
                attrs: {
                  effect: "dark",
                  "open-filter": true,
                  placement: "top",
                },
              },
              [
                _c(
                  "span",
                  { staticClass: "tooltip" },
                  [
                    _c("yxtbiz-user-name", {
                      attrs: {
                        name:
                          (_vm.value[0] && _vm.value[0].fullname) ||
                          _vm.$t("pc_biz_notadded" /* 暂未添加 */),
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { attrs: { slot: "content" }, slot: "content" },
                  [
                    _c("yxtbiz-user-name", {
                      attrs: {
                        name:
                          (_vm.value[0] && _vm.value[0].fullname) ||
                          _vm.$t("pc_biz_notadded" /* 暂未添加 */),
                      },
                    }),
                  ],
                  1
                ),
              ]
            ),
            _c(
              "span",
              {
                staticClass: "tlive-create__teacher--choose",
                on: { click: _vm.showDialog },
              },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("pc_biz_replaceLecturer" /* 更换讲师 */)) +
                    "\n      "
                ),
              ]
            ),
          ],
          1
        ),
      ]),
      _c(
        "yxt-drawer",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.chooseLoading,
              expression: "chooseLoading",
            },
          ],
          attrs: {
            "before-close": _vm.onStudentBeforeClose,
            "header-border": false,
            "destroy-on-close": true,
            size: "960px",
            visible: _vm.dialogVisible,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("yxt-user-selector", {
            ref: "selector",
            attrs: {
              data: [],
              tabs: _vm.tabs,
              "function-code": _vm.isGroupOrg
                ? "group_task_center"
                : "tlive_mgmt_list",
              "data-permission-code": _vm.isGroupOrg
                ? "task_manage_platform"
                : "tlive_mgmt_extent",
              enableGroupCorp: _vm.isGroupOrg,
            },
          }),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "yxt-button",
                {
                  attrs: { plain: "" },
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("pc_biz_core_btn_cancel" /* 取消 */)) +
                      "\n        "
                  ),
                ]
              ),
              _c(
                "yxt-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.getTeacher("student")
                    },
                  },
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("pc_biz_core_btn_determine" /* 确认 */)) +
                      "\n        "
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }